// extracted by mini-css-extract-plugin
module.exports = {"Select-animation-fadeIn":"_3cZxx_Q23daDbPTwIpKRjc","Select-animation-spin":"_2wN-WZiQnzTZ2S6QOb6GuE"};